import PropTypes from 'prop-types'
import Tooltip from 'components/tooltip/Tooltip'
import NoneAnchor from 'components/NoneAnchor'

/*
 * 도움말 버튼에 노출되는 툴팁
 */
const HelpTooltip = ({
  children,
  position = 'top alignLeft',
  className,
  nowrap,
  tag = 'a',
  marginTop,
  container,
  style,
}) => {
  const TagName = tag === 'a' ? NoneAnchor : tag
  return (
    children && (
      <Tooltip
        content={children}
        position={position}
        className={className}
        nowrap={nowrap}
        container={container}
        style={style}>
        <TagName
          className="link_g link_help"
          style={{
            ...(marginTop && { marginTop }),
            ...(tag !== 'a' && { cursor: 'pointer' }),
          }}>
          <span className="ico_comm ico_help">도움말</span>
        </TagName>
      </Tooltip>
    )
  )
}

HelpTooltip.propTypes = {
  position: Tooltip.propTypes.position,
  children: PropTypes.node,
  className: PropTypes.string,
  nowrap: PropTypes.bool,
  tag: PropTypes.string,
  marginTop: PropTypes.number,
  container: PropTypes.node,
  style: PropTypes.object,
}

export default HelpTooltip
